import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DeviceRelocationService} from "./device-relocation.service";
import {SiteService} from "../sites/site.service";
import {handleErrors} from "../misc/handle-errors.decorator";

export interface RelocationCreateInputModel {
  projectId: string;
  siteId: string;
}

@Component({
  templateUrl: "./create-relocation-dialog.template.pug",
  providers: [
    DeviceRelocationService,
    SiteService,
  ],
})
export class CreateRelocationDialogComponent extends DialogComponent<RelocationCreateInputModel, boolean>
  implements RelocationCreateInputModel {
  public projectId: string;
  public siteId: string;
  public error: Error;
  public relocationName: string;
  public sites: any[] = [];

  static showCreateDialog(dialogService: DialogService, input: RelocationCreateInputModel): Promise<boolean> {
    return dialogService.showDialog(CreateRelocationDialogComponent, input);
  }

  ngOnInit(): void {
    this.loadData();
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  @handleErrors()
  async loadData(): Promise<void> {
    if (this.projectId && !this.siteId) {
      const sitesResponse = await this.siteService.getSitesByProjectId(this.projectId);
      this.sites = sitesResponse || [];
      if (this.sites.length === 1) {
        this.siteId = this.sites[0].id;
      }
    } else if (!this.siteId) {
      throw new Error("Site or Project are required to create a defect.");
    }
  }

  @handleErrors()
  async save(): Promise<void> {
    await this.deviceRelocationService.saveRelocation(this.relocationName, this.siteId);
    this.result = true;
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    public deviceRelocationService: DeviceRelocationService,
    public siteService: SiteService,
  ) {
    super(dialogService);
  }
}
